<template>
    <div>
        <b-form class="formAnalyze">
            <b-form-group class="inputFile" id="input-group-statut">
                <label class="labelCreateTicket">Fichiers</label>
                <b-form-file
                    v-model="fileList"
                    :state="Array(fileList)"
                    placeholder="Choisir des fichiers ou les déposer ici..."
                    drop-placeholder="Déposer ici..."
                    multiple
                    accept=".vcf"
                ></b-form-file>
            </b-form-group>
            <div class="buttonAnalyze">
              <b-button id="analyzeContact" @click="analyzeContact(fileList)" variant="primary">Analyser les contacts</b-button>
            </div>
        </b-form>
        <div class="contactsList">
          <el-card v-for="(contact, index) in contactsList" :key="index" class="box-card contactCard">
            <el-form :model="contact">
              <el-form-item class="itemForm">
                <el-col class="colItem" :span="8">
                  <label class="labelInput" for="nom">Nom</label>
                  <el-input placeholder="Nom" name="nom" v-model="contact.lastname"></el-input>
                </el-col>
                <el-col class="colItem" :span="8">
                  <label class="labelInput" for="prenom">Prénom</label>
                  <el-input placeholder="Prénom" name="prenom" v-model="contact.firstname"></el-input>
                </el-col>
                <el-col class="colItem" :span="8">
                  <label class="labelInput" for="tel">Téléphone</label>
                  <el-input placeholder="Téléphone" name="tel" v-model="contact.phone"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="itemForm">
                <el-col class="colItem" :span="12">
                  <label class="labelInput" for="mail">E-Mail</label>
                  <el-input placeholder="E-mail" name="mail" v-model="contact.email"></el-input>
                </el-col>
                <el-col class="colItem" :span="12">
                  <label class="labelInput" for="poste">Poste</label>
                  <el-input placeholder="Poste" name="poste" v-model="contact.title"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="itemForm">
                <el-col class="colItem">
                  <label class="labelInput" for="privateNote">Note privée</label>
                  <el-input placeholder="Note privée" name="privateNote" v-model="contact.privateNote"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="itemForm">
                <el-col class="colItem">
                  <label class="labelInput" for="address">Adresse</label>
                  <el-input placeholder="Adresse" name="address" v-model="contact.address"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="itemForm">
                <el-col class="colItem" :span="12">
                  <label class="labelInput" for="zip">Code postal</label>
                  <el-input placeholder="Code postal" name="zip" v-model="contact.zip"></el-input>
                </el-col>
                <el-col class="colItem" :span="12">
                  <label class="labelInput" for="city">Ville</label>
                  <el-input placeholder="Ville" name="city" v-model="contact.town"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="itemForm">
                <el-col class="colItem" :span="12">
                  <label class="labelInput" for="organisation">Organisation</label>
                  <el-input placeholder="Organisation" name="organisation" v-model="contact.organization"></el-input>
                </el-col>
                <el-col class="colItem" :span="12">
                  <label class="labelInput" for="url">Url site internet</label>
                  <el-input placeholder="Url" name="url" v-model="contact.url"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="itemForm">
                <el-col class="colItem">
                  <label class="labelInput" for="note">Note</label>
                  <el-input placeholder="Note" name="note" v-model="contact.note"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="itemForm">
                <el-col class="colItem">
                  <el-popover v-if="contact.isContactCreated" placement="top-start" width="250" trigger="hover" content="Le contact éxiste déjà dans Dolibarr">
                      <el-button slot="reference" type="primary" disabled>Créer le Contact</el-button>
                  </el-popover>
                  <el-button v-else type="primary" @click="createContact(contact,index)">Créer le Contact</el-button>

                  <!-- <el-popover v-if="contact.isTiersCreated" placement="top-start" width="250" trigger="hover" content="Le tiers éxiste déjà dans Dolibarr">
                      <el-button slot="reference" type="primary" disabled>Créer le Tiers</el-button>
                  </el-popover>
                  <el-button v-else type="primary">Créer le Tiers</el-button> -->
                </el-col>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
    </div>   
</template>

<script>
import script from '../../../../script/script_tiers.js';
var moment = require('moment')

export default {
  data() {
    return {
      fileList: [],
      contactsList: [],
    }
  },
  mounted:function(){
    this.verifyRight();
  },
  methods: {
    verifyRight: script.verifyRight,
    analyzeContact: script.analyzeContact,
    createContactVcf: script.createContactVcf,
    createContact(contact,index) {
      script.createContactVcf(contact,index,this);
    }
  },
  components: {
    
  },
  computed:{
    info(){
      return this.$store.state.info
    },
  }
  
}
</script>

<style scoped>
.contactsList {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    justify-content: space-evenly;
}
.contactCard {
    flex: 0 0 40%;
}

.labelInput{
  margin-bottom: 0px;
}

.itemForm {
  margin-bottom: 0px;
}

.colItem{
  padding : 0 .5em;
}

.formAnalyze{
  display: flex;
  align-items: flex-end;
}

.inputFile{
  flex: 0 0 35%;
  padding: 0.5em;
  margin: 0;
}

.buttonAnalyze {
  padding: 0.5em;
}
</style>
